import { UpdateCategoryPayload } from '@models/payload/category';
import { IPaginationInput } from '@models/payload/customer';
import { SellChannel } from '@models/ropolo';
import { ropoloRequest } from '@services/axios';

const getMenuCategories = async (params: IPaginationInput) =>
  (await ropoloRequest.catalogMenucategoriesList(params)).data;

const getMenuCategoriesWithMenuItems = async ({
  sellChannel = [SellChannel.SALON],
  vendorId,
}: {
  sellChannel?: SellChannel[] | SellChannel;
  vendorId?: string;
}) => (await ropoloRequest.catalogMenucategoriesSiteList({ sellChannel: sellChannel as any, vendorId })).data;

const getAllMenuCategoriesWithMenuItems = async () => (await ropoloRequest.catalogMenucategoriesPrinterList()).data;

const getFoodMenuCategoriesWithMenuItems = async () => (await ropoloRequest.snappfoodMenucategoriesList()).data;

const getMenuCategoriesServerSideWithMenuItems = async (
  hostDomain: string,
  baseUrl: string,
  clientIp?: string,
  sellChannel: SellChannel = SellChannel.QR
) =>
  (
    await ropoloRequest.server.catalogMenucategoriesSiteList(
      { sellChannel },
      { headers: { hostDomain, 'X-Forwarded-For': (clientIp as string) || '' }, baseURL: baseUrl }
    )
  ).data;

const updateCategory = async (command: UpdateCategoryPayload) =>
  (await ropoloRequest.snappfoodMenucategoriesUpdate(command)).data;

const createCategory = async (command: UpdateCategoryPayload) =>
  (await ropoloRequest.snappfoodMenucategoriesCreate(command)).data;

const changeCategoryActivation = async (id: string) =>
  (await ropoloRequest.snappfoodMenucategoriesActivationUpdate(id)).data;

const syncBySnappFood = async (id: string) =>
  (await ropoloRequest.snappfoodMenucategoriesSendtosnappfoodUpdate(id)).data;

const categoryService = {
  getMenuCategories,
  getMenuCategoriesWithMenuItems,
  updateCategory,
  createCategory,
  getFoodMenuCategoriesWithMenuItems,
  getMenuCategoriesServerSideWithMenuItems,
  changeCategoryActivation,
  syncBySnappFood,
  getAllMenuCategoriesWithMenuItems,
};

export default categoryService;
